/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2020, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import PropTypes from 'prop-types';

const SCRIPT_ID = 'SegmentScript';

export interface SegmentScriptProps {
  src: string;
}

const SegmentScript: React.FC<SegmentScriptProps> = ({ src }) => {
  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = src;
    document.body.appendChild(script);
  }
  return null;
};

SegmentScript.propTypes = {
  src: PropTypes.string
};

export default SegmentScript;
